<template>
  <form-panel
    width="medium"
    title="Contenido"
    @closePanel="onClose">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      class="campaign-email-panel padding-20"
      @submit.native.prevent="onSubmit">
      <h5>Redacta el contenido de tu email</h5>
      <div class="upload">
        <el-form-item prop="imageUrl">
          <el-upload
            ref="fileUploader"
            :action="uploadURL"
            :headers="headers"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            class="upload-demo"
            name="picture"
            drag>
            <div class="content-upload">
              <img
                v-if="model.imageUrl"
                :src="model.imageUrl"
                class="avatar">
              <div
                v-else
                class="actions-upload">
                <i class="icon-upload-cloud"/>
                <div class="el-upload__text">
                  Arrastra aquí tu archivo ó
                  <br>
                  <el-button type="primary">Buscar en el equipo</el-button>
                </div>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </div>
      <span class="foot-note">
        <strong>Formatos permitidos: JPG, JPEG, PNG, GIF. Tu imagen debe medir 550 x 250 y tener un peso menor de 2MB</strong>
      </span>
      <div class="editor">
        <el-form-item prop="textContent">
          <wysiwyg
            v-model="model.textContent"
            :options="editorOptions"
            placeholder="Escriba el texto del email"/>
        </el-form-item>
      </div>
      <el-row
        type="flex"
        justify="end">
        <el-col :span="12">
          <el-button
            type="primary"
            native-type="submit">
            Guardar
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </form-panel>
</template>

<script>
import AuthService from '@/services/auth.service'
import FormPanel from '@/components/_shared/form-panel'
import ContainModel from '@/models/campaigns/campaign-contain-model.js'
export default {
  name: 'CampaignEmailPanel',
  components: {
    FormPanel
  },
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: ContainModel.model(),
      rules: ContainModel.rules(),
      textContent: '',
      uploadURL: `${process.env.API_URL}campaign-contents/upload`,
      imageUrl: '',
      imageFile: null,
      oldImgName: '',
      editorOptions: {
        hideModules: {
          headings: true,
          code: true,
          orderedList: true,
          unorderedList: true,
          image: true,
          table: true,
          removeFormat: true
        },
        maxHeight: '50vh'
      }
    }
  },
  computed: {
    headers () {
      return {
        authorization: AuthService.token()
      }
    }
  },
  mounted () {
    if (this.message.banner || this.message.content) {
      this.model.imageUrl = `${process.env.API_URL_IMAGES}${this.message.banner}`
      this.model.textContent = this.message.content
      this.oldImgName = this.message.banner
    }
  },
  methods: {
    onClose () {
      this.$store.dispatch('app/toggleCampaignMailPanel')
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      const isJPG = file.type === 'image/jpg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'

      if (!isJPG && !isJPEG && !isPNG && !isGIF) {
        this.$message.error('El formato del archivo no es correcto.')
      }
      if (!isLt2M) {
        this.$message.error('El archivo excede el peso permitido.')
      }
      return (isJPG || isJPEG || isPNG || isGIF) && isLt2M
    },
    beforeRemove (e) {
      console.log('Before remove', e)
      this.model.imageUrl = ''
    },
    handleRemove (e) {
      console.log('Handle remove', e)
    },
    handlePreview (e) {
      console.log('Handle preview', e)
    },
    handleSuccess (e, file, fileList) {
      this.model.imageUrl = URL.createObjectURL(file.raw)
      this.imageFile = file
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.message !== null) {
            let image = this.imageFile !== null ? this.imageFile.response : this.oldImgName
            let contentMail = {
              nameImg: image,
              content: this.model.textContent
            }
            this.$emit('onSendContent', contentMail)
            this.$message.success('El contenido se agregó correctamente')
            this.$store.dispatch('app/toggleCampaignMailPanel')
          } else {
            let contentMail = {
              nameImg: this.imageFile.response,
              content: this.model.textContent
            }
            if (this.model.textContent !== '' && this.imageFile !== null) {
              this.$emit('onSendContent', contentMail)
              this.$message.success('El contenido se agregó correctamente')
              this.$store.dispatch('app/toggleCampaignMailPanel')
            } else {
              this.$message.error('Verifique si los datos se han completado')
            }
          }
        }
      })
    },
    showPreview () {
      this.$store.dispatch('app/toogglePreviewMail')
    }
  }
}
</script>

<style scoped lang="scss">
.campaign-email-panel{
  h5{
    margin: 0 0 15px 0;
    @include font-lato(14px, regular);
    color: #B5AFAF;
  }
  .upload{
    min-height: 200px;
    .upload-demo{
      display: flex;
      flex-direction: column;
      .content-upload{
        height: 100%;
        margin: 0;
        display: flex;
        justify-content: center;
        .actions-upload{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          .el-button{
            box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
          }
        }
        .avatar {
          height: 100%;
          display: block;
        }
      }
    }
  }
  .editor{
    margin-top: 10px;
  }
  .el-button {
    background-color: $primary;
    color: #ffffff;
    width: 100%;
    box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-email-panel.vue